
import MenuRightSerivce from "@/service/MenuRightService";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import SweetAlertService from "@/service/SweetAlertService";
import { AnnualLeaveKey, CompensationKey } from "@/constants/globalConstants";
import StoreGetter from "@/constants/StoreGetter";
import { IncType } from "@/model/IncType";
import Settings from "@/constants/Settings";
import PayrollAdjustmentService from "@/service/PayrollAdjustmentService";
export default {
    name: "incType",
    components: {},
    computed: {
        t() {
            return t;
        }
    },

    data() {
        return {
            annualLeaveKey: AnnualLeaveKey,
            compensationKey: CompensationKey,
            menuRights: { allRights: {}, rightsForThisMenu: {} },
            menuId: Settings.MenuID.S_IncType,
            Settings: Settings,
            tableData: [],
            dictEnum: dictEnum,
            incType: new IncType(),
            mode: "new",
            currentPage: 1,
            perPage: 15,
            fields: [
                {
                    key: "IncTypeDesc",
                    label: t.t(dictEnum.LBL_IncType)
                },
                {
                    key: "IncSubType",
                    label: t.t(dictEnum.LBL_IncSubType)
                },
                {
                    key: "IR56BRow",
                    label: t.t(dictEnum.LBL_IR56BRow)
                },
                {
                    key: "MPF",
                    label: t.t(dictEnum.LBL_MPF)
                },
                {
                    key: "Action",
                    label: ""
                }
            ]
        };
    },

    methods: {
        hasRight(key, menuId) {
            if (Object.keys(this.menuRights.allRights).length === 0) {
                return false;
            } else {
                return MenuRightSerivce.hasRightInMenu(
                    this.menuRights.allRights,
                    menuId ? menuId : this.menuId,
                    key
                );
            }
        },
        assignRights() {
            this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];
            this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
                x => x.MenuID == this.menuId
            );
        },
        initIncType() {
            this.mode = "new";
            this.incType = new IncType();
            $('#modal-incType').modal('show');
        },

        OnIncTypeSelect(model) {
            this.incType = JSON.parse(JSON.stringify(model));
        },

        rowClass(item, type) {
            let colorClass = "";
            if (!item || type !== "row") return;
            if (
                item.IncTypeDesc == this.incType.IncTypeDesc &&
                item.IncSubType == this.incType.IncSubType
            ) {
                colorClass = "selected-tr";
            }
            return colorClass;
        },

        onEditIncType() {
            this.mode = "edit";
            if (this.incType) {
                $('#modal-incType').modal('show');
            }
            else {
                SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_SelectDeleteRecord));
            }
        },

        closeIncTypeModel() {
            $('#modal-incType').modal('hide');
        },

        delIncTypeModelShow() {
            if (this.incType) {
                $('#delIncTypeModel').modal('show');
            }
            else {
                SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_SelectDeleteRecord));
            }
        },

        async deleteIncType() {
            const obj = {
                model: this.incType
            };

            const response = await PayrollAdjustmentService.deleteIncType(obj);
            if (response.data.IsSuccess) {
                SweetAlertService.success("Success", response.data.Message);
                this.getDataTable();
                $('#delIncTypeModel').modal('hide');
            }
        },

        async editOrAddIncType() {
            if (!this.incType.IncTypeDesc) {
                SweetAlertService.warning(
                    "Warn",
                    t.t(dictEnum.LBL_Description) + t.t(dictEnum.WARN_IsRequired)
                );
                return;
            }

            if (!this.incType.IncSubType) {
                SweetAlertService.warning(
                    "Warn",
                    t.t(dictEnum.LBL_IncSubType) + t.t(dictEnum.WARN_IsRequired)
                );
                return;
            }
            if (!this.incType.IR56BRow) {
                SweetAlertService.warning(
                    "Warn",
                    t.t(dictEnum.LBL_IR56BRow) + t.t(dictEnum.WARN_IsRequired)
                );
                return;
            }

            const obj = {
                model: this.incType
            };

            const response = await PayrollAdjustmentService.saveIncType(obj);
            if (response.data.IsSuccess) {
                SweetAlertService.success("Success", response.data.Message);
                this.getDataTable();
                this.closeIncTypeModel();
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },

        async getDataTable() {
            const obj = {};
            const response = await PayrollAdjustmentService.getIncTypeList(obj);
            if (!response.data.IsSuccess) {
                SweetAlertService.warning("Warn", response.data.Message);
            } else {
                this.tableData = response.data.Data;
            }
        }
    },

    mounted() {
        this.assignRights();
        this.getDataTable();
    }
};


// WEBPACK FOOTER //
// ./src/components/S080000-Setup/082300-IncType/S082300-IncType.js